module.exports = __webpack_public_path__ + "static/Regulamin_e_containers_eu_de-47c677355e2d449b6915c540f40c9eb0.pdf";